import React from "react";
import DocumentsPanel from "./components/DocumentsPanel";
import styles from "./Documents.module.scss";

/**
 * LS-693 — menu global « Documents ».
 *
 * Point d'accès unique aux documents d'un véhicule, quelle que soit l'étape de
 * son cycle de vie à laquelle ils ont été déposés (conditions particulières de
 * la ligne de devis, documents de la demande de financement).
 *
 * La visibilité n'est pas décidée ici : chaque source applique la sienne côté
 * API. Un commercial voit donc tous les documents de financement mais seulement
 * les conditions particulières des devis qui lui sont assignés — asymétrie
 * connue et assumée (cf. docs/Documents/documents-vehicule.md côté API).
 */
const DocumentsList = () => (
  <div className={styles.page}>
    <div className={styles.header}>
      <h1>Documents</h1>
      <p className={styles.subtitle}>
        Tous les documents rattachés à un véhicule, devis et financement
        confondus. Consultation et téléchargement uniquement — le dépôt reste
        dans son module d'origine.
      </p>
    </div>

    <DocumentsPanel filtresEtendus />
  </div>
);

export default DocumentsList;
